import {type BlokAsset} from "../types";
import {
	type SimpleProductDataFragment,
	ProductMediaShotType,
	ProductMediaOrientation,
} from "../graphql";

type Media = SimpleProductDataFragment["medias"][0];

/**
 * Try to extract dimensions from the url
 * https://www.storyblok.com/docs/concepts/assets#obtain-image-dimensions-via-the-api
 *
 * Example url: "//a.storyblok.com/f/51376/664x488/f4f9d1769c/visual-editor-features.webp"
 */
export function parseDimensionsFromUrl(url: string | undefined | null) {
	const [width, height] = url?.split("/", 6)?.[5]?.split("x") ?? [];

	return {
		width: Number(width ?? "") || 1920,
		height: Number(height ?? "") || 1080,
	};
}

/** Transform image object.
 * In order to get image from Storblok to work among with product images we have to transform it to Media object.
 */
export default function transformImageObject(object: BlokAsset): Media {
	const dimensions = parseDimensionsFromUrl(object.filename);
	return {
		__typename: "ProductImage",
		id: object.id,
		title: object.alt,
		url: object.filename || "",
		shotType: ProductMediaShotType.WhiteBackground,
		orientation: ProductMediaOrientation.Landscape,
		position: 999, // 999 to make sure it's last.
		isDefault: false,
		...dimensions,
	};
}
